import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton
} from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
  LeftPanelCloseOutlined
} from '../../../../../Common/components/Icons/icons';

import {
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import {
  pastButtonIconSx,
  pastButtonSx,
  pastButtonWrapperSx,
  visitDateRowSx
} from './SoapEntryStyles';

const VisitDateSection = ({
  isPast,
  visitDate,
  onVisitDateChange,
  onExpandPast
}) => {
  return (
    <Box sx={visitDateRowSx}>
      <DatePicker
        format="MM/DD/YYYY"
        label="Visit Date"
        value={visitDate}
        onChange={onVisitDateChange}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            sx: textFieldSx
          }
        }}
      />

      {isPast && (
        <Box sx={pastButtonWrapperSx}>
          <IconButton
            size="small"
            aria-label="Expand past SOAP notes"
            onClick={onExpandPast}
            sx={pastButtonSx}>
            <LeftPanelCloseOutlined sx={pastButtonIconSx} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

VisitDateSection.propTypes = {
  isPast: PropTypes.bool,
  visitDate: PropTypes.object,
  onVisitDateChange: PropTypes.func.isRequired,
  onExpandPast: PropTypes.func
};

export default VisitDateSection;